import { API, graphqlOperation } from "aws-amplify";
import ConfirmationModal from "@/components/widgets/ConfirmationModal2.vue";

const CANCEL_RECURRING_PAYMENT_MUTATION = ` mutation CancelRecurringPayment(
$body: MutationModifyTransactionBodyInput
){
  modifyTransaction(body: $body){
    TransactionStatus
    Successful
  }
}`;

export default {
  components: { ConfirmationModal },
  data() {
    return {
      isShowSnackBar: false,
      snackBarMessage: "",
      isShowConfirmationModal: false,
      confirmationModalInfo: {
        title: "Cancelation",
        message: "Are You Sure You Want To Cancel This Recurring Payment?",
        confirmButtonTitle: "Yes",
        cancelButtonTitle: "No"
      },
      confirmationModalInfoColor: {
        titleColor: "red",
        confirmButtonTitleColor: "red"
      }
    };
  },
  computed: {
    hasCancelRecurringPaymentPermission() {
      return this.$role.verify([
        this.$role.MERCHANT_ADMIN,
        this.$role.CANCEL_RECURRING_PAYMENT
      ]);
    },
    recurringStatus() {
      return (
        this.value.recurringStatus == "OnGoing" ||
        this.value.recurringStatus == "CancelError" ||
        this.value.recurringStatus == "Scheduled"
      );
    },
    tenantAlias() {
      return this.$store.getters.merchantId;
    },
    paymentRequestId() {
      return this.value.paymentRequestId;
    }
  },
  methods: {
    async cancelRecurringPayment() {
      let mutationModifyTransactionBodyInput = {
        ModificationRequest: {
          TenantAlias: this.tenantAlias,
          PaymentRequestId: this.paymentRequestId,
          ModificationOperation: "CancelRecurring"
        }
      };

      try {
        this.$refs.confirmation.loading();
        const response = await API.graphql(
          graphqlOperation(CANCEL_RECURRING_PAYMENT_MUTATION, {
            body: mutationModifyTransactionBodyInput
          })
        );
        this.$refs.confirmation.stopLoading();

        if (response.data.modifyTransaction.Successful) {
          this.reloadDetailedModal(this.value);
          this.showSnackBarMessage("Successfully Canceled Recurring Payment");
        }
      } catch (err) {
        this.$refs.confirmation.stopLoading();
        if (err.errors[0].errorType == "ExecutionTimeout") {
          this.reloadDetailedModal(this.value);
          this.showSnackBarMessage("Successfully Canceled Recurring Payment");
        } else {
          this.showSnackBarMessage(
            "An Error Occurred While Cancelling Recurring Payment"
          );
        }
        this.$logger.error(err);
      }
    },
    showSnackBarMessage(message) {
      this.snackBarMessage = message;
      this.isShowSnackBar = true;
    },
    hideSnackBarMessage() {
      this.snackBarMessage = "";
      this.isShowSnackBar = false;
    },
    openConfirmation() {
      this.isShowConfirmationModal = true;
    },
    cancelConfirmation() {
      this.isShowConfirmationModal = false;
    },
    reloadDetailedModal(item) {
      this.cancelConfirmation();
      this.closeModal();
      this.$emit("eReloadDetailedModal", item);
    }
  }
};
